export default __webpack_public_path__ + "static/media/rotaryPhone.85d27613.mp3";